<div class="appContainer">

  <div class="top_banner">
    <h1 class="text-center"> Marketplace</h1>
  </div>


  <div class="app-body">

    <main class="main">
      <div class="container">
        <h2>{{page_title}}</h2>
        <div class="card-body-filter">
          <form [formGroup]="searchForm">
            <div class="row">
              <div class="col-sm-2">
                <ng-select (change)="selectedCatergory()" appearance="" [searchable]="false" [clearable]="false"
                  labelForId="categoryBy" formControlName="categoryBy">
                  <ng-option value="all">
                    All Categories
                  </ng-option>
                  <ng-option *ngFor="let item of categories" value="{{item._id}}">
                    <!-- <img src="../../../assets/images/{{item.coinValue}}-icon.svg" width="20px" height="20px" /> -->
                    {{item.title}}
                  </ng-option>
                  <!-- <ng-option value="spidey">
                        <img src="{{basePath}}/assets/spidey.png" width="20px" height="20px" />
                        Spider-Man & Goblin
                      </ng-option>
                      <ng-option value="thor">
                        <img src="{{basePath}}/assets/thor.png" width="20px" height="20px" />
                        Thor
                      </ng-option> -->
                </ng-select>
              </div>
              <div class="col-sm-2">
                <ng-select (change)="selectedCollection()" appearance="" [searchable]="false" [clearable]="false"
                labelForId="categoryBy" formControlName="collection_id">
                <ng-option value="all">
                  All Collection
                </ng-option>
                <ng-option *ngFor="let item of collections" value="{{item._id}}">
                  {{item.name}}
                </ng-option>
              </ng-select>
              </div>
              <div class="col-sm-2">
                <ng-select (change)="selectedSortBy()" appearance="" [searchable]="false" [clearable]="false"
                  labelForId="sortBy" formControlName="sortBy">
                  <ng-option value="all">
                    Sort BY ALL
                  </ng-option>
                  <ng-option value="recent">
                    Recent
                  </ng-option>
                  <ng-option value="mostviewed">
                    <!-- <img src="../../../assets/images/{{item.coinValue}}-icon.svg" width="20px" height="20px" /> -->
                    Most Viewed
                  </ng-option>
                  <ng-option value="mostliked">
                    <!-- <img src="{{basePath}}/assets/thor.png" width="20px" height="20px" /> -->
                    Most Liked
                  </ng-option>
                  <ng-option value="offer">
                    <!-- <img src="{{basePath}}/assets/spidey.png" width="20px" height="20px" /> -->
                    On Auction
                  </ng-option>
                </ng-select>
              </div>
              <div class="col-sm-2">
                <ng-select (change)="selectedPrice()" appearance="" [searchable]="false" [clearable]="false"
                  labelForId="price" formControlName="price">
                  <ng-option value="1">
                    > 1 GDCC
                  </ng-option>
                  <ng-option value="10">
                    > 10 GDCC
                  </ng-option>
                  <ng-option value="100">
                    > 100 GDCC
                  </ng-option>
                  <ng-option value="1000">
                    > 1000 GDCC
                  </ng-option>
                </ng-select>
              </div>
              <div class="col-sm-2">
                <div>
                  <input type="text" class="form-control" formControlName="searchItemBy" id="name" placeholder="Search"
                    [(ngModel)]="searchInput" (keyup.enter)="searchAction()">
                    <div class="card-body-filter-action">
                    <button type="submit" class="btn btn-primary" (click)="searchAction()"><i
                      class="fa fa-search"></i></button>
                      </div>

                </div>
              </div>
              <!-- <div class="col-sm-2">
                <div class="card-body-filter-action">
                  <button type="submit" class="btn btn-primary" (click)="searchAction()"><i
                      class="fa fa-search"></i>Search</button>
                  <button type="submit" class="btn btn-primary" (click)="resetAction()"><i
                      class="fa fa-refresh"></i>Reset</button>
                </div>
              </div> -->
            </div>
          </form>
        </div>
        <div class="collectionMainContainer" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
          (scrolled)="onNextPage()">
          <app-itemskeleton *ngIf="loading"></app-itemskeleton>
          <app-nodata *ngIf="!loading && items.length==0" msg="There is no data to display here"></app-nodata>
          <div class="row" *ngIf="!loading && items.length>0">
            <div class="col-md-3" *ngFor="let item of items">
              <app-item [isUserIP]="isUser" [item]="item" (itemEvent)="itemEvent($event)"> </app-item>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</div>